<div class="slider" *ngrxLet="{ currentSlide: currentSlide$, news: news$, shouldShowDetailsButton: shouldShowDetailsButton$ } as vm">
    <button
        class="button-icon left-arrow"
        type="button"
        (click)="previousSlide()"
        *ngIf="vm.news.length > 1"
        [attr.aria-label]="'dtmUi.carousel.previousSlideAriaLabel' | transloco"
    >
        <dtm-ui-icon name="arrow-left"></dtm-ui-icon>
    </button>
    <ul class="slides">
        <ng-container *ngFor="let slide of vm.news; let index = index">
            <li class="slide" [ngClass]="{ hideLeft: index < vm.currentSlide, hideRight: index > vm.currentSlide }">
                <div class="date" *ngIf="slide.newsDate as date">{{ date | localizeDate }}</div>
                <h3 *ngIf="slide.newsTitle as title">{{ title }}</h3>
                <div
                    class="preview"
                    [dtmUtilsEllipsifyHtml]="+slide.previewLength"
                    (hasEllipsisChange)="onHasEllipsisChanged()"
                    #previewContentEllipsisInfo="ellipsifyHtml"
                >
                    <p *ngIf="slide.previewContent | invoke : isString" [innerHTML]="slide.previewContent"></p>
                    <ng-container [ngTemplateOutlet]="slide | invokeThis : getPreviewTemplate : this"></ng-container>
                </div>
            </li>
        </ng-container>
    </ul>
    <div class="controls">
        <span class="slides-info" *ngIf="vm.news.length > 1">
            {{ "dtmMainPageLib.subpage.kpo.news.slideOfLabel" | transloco : { current: vm.currentSlide + 1, total: vm.news.length } }}
        </span>
        <button type="button" class="button-secondary" (click)="openDetails()" *ngIf="vm.shouldShowDetailsButton">
            {{ "dtmMainPageLib.subpage.kpo.news.readMoreLinkText" | transloco }} <dtm-ui-icon name="arrow-go"></dtm-ui-icon>
        </button>
    </div>
    <button
        class="button-icon right-arrow"
        type="button"
        (click)="nextSlide()"
        *ngIf="vm.news.length > 1"
        [attr.aria-label]="'dtmUi.carousel.nextSlideAriaLabel' | transloco"
    >
        <dtm-ui-icon name="arrow-right"></dtm-ui-icon>
    </button>
</div>
